import { Typography } from './typography'

const {
  H1,
  PublicH1,
  H3,
  H2,
  InputText,
  SmallText,
  Label,
  PublicLabel,
  InputSmallText,
  ErrorText,
  NotificationText,
  ButtonText,
  ButtonSmallText,
  Legend,
  TabText,
  Paragraph,
  Log,
} = Typography

export {
  H1,
  PublicH1,
  H3,
  H2,
  InputText,
  SmallText,
  Label,
  PublicLabel,
  InputSmallText,
  ErrorText,
  ButtonText,
  ButtonSmallText,
  Legend,
  TabText,
  Paragraph,
  NotificationText,
  Log,
}

export type { StyledSystemProps } from './atoms/dynamic-styled-system-component'
